// API service for backend communication
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const sendContactMessage = async (formData) => {
  try {
    console.log('Sending to:', `${API_URL}/api/contact`);
    console.log('Form data:', formData);
    
    const response = await fetch(`${API_URL}/api/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    console.log('Response status:', response.status);
    
    // Check if response is OK
    if (!response.ok) {
      const errorText = await response.text();
      console.error('Error response:', errorText);
      throw new Error(`Server error: ${response.status}`);
    }
    
    const data = await response.json();
    console.log('Response data:', data);
    
    return data;
  } catch (error) {
    console.error('Contact form error:', error);
    throw new Error(error.message || 'Failed to send message. Please try again.');
  }
};

export const submitJobApplication = async (formData, resumeFile, educationData, experienceData) => {
  const formDataObj = new FormData();
  
  Object.keys(formData).forEach(key => {
    if (formData[key] !== undefined && formData[key] !== null && formData[key] !== '') {
      formDataObj.append(key, formData[key]);
    }
  });
  
  formDataObj.append('education', JSON.stringify(educationData));
  formDataObj.append('experience', JSON.stringify(experienceData));
  
  if (resumeFile) {
    formDataObj.append('resume', resumeFile);
  }

  try {
    console.log('Submitting to:', `${API_URL}/api/job-application`);
    
    const response = await fetch(`${API_URL}/api/job-application`, {
      method: 'POST',
      body: formDataObj,
    });

    console.log('Response status:', response.status);
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('Error response:', errorText);
      throw new Error(`Server error: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Job application error:', error);
    throw error;
  }
};

// Health check function
export const checkBackendHealth = async () => {
  try {
    const response = await fetch(`${API_URL}/api/health`);
    if (!response.ok) return false;
    const data = await response.json();
    return data.status === 'OK';
  } catch (error) {
    console.error('Backend health check failed:', error);
    return false;
  }
};